import { create } from "zustand";
import { deleteCookie } from "cookies-next";
import { getCartRest } from "../bigcommerce/restfull/apis/cartAPIS";
import { persist } from "zustand/middleware";
import { setCartCookies } from "../User/action";
import useCountryStore from "./useCountryStore";
import useCheckoutStatus from "./useCheckoutStatus";
import {
    Checkout,
    UpdateShippingMethod,
} from "../bigcommerce/Checkout/actions";
import { Error } from "@/public/Constants/ErrorConstants";
import { getCheckoutRest } from "../bigcommerce/restfull/apis/checkoutAPIS";

const useCartStore = create(
    persist(
        (set, get) => ({
            cartId: null,
            cartData: null,
            cartLoading: false,
            checkoutDetails: null,
            checkoutLoading: false,
            hasCartHydrated: false,

            updateCartData(data) {
                const { clearCart } = get();
                if (data?.id) {
                    setCartCookies(data?.id);
                    set({ cartData: data, cartId: data?.id });
                } else clearCart();
            },

            clearCart() {
                const { cartData, cartId, checkoutDetails } = get();
                if (cartData || cartId || checkoutDetails) {
                    deleteCookie("cartId", null);
                    set({
                        cartData: null,
                        cartId: null,
                        checkoutDetails: null,
                        cartLoading: false,
                    });
                }
            },

            clearCartData() {
                set({
                    cartData: null,
                    checkoutDetails: null,
                    cartLoading: false,
                });
            },

            setCheckoutDetails(checkoutDetails) {
                useCheckoutStatus?.getState()?.resetPaymentStatus();
                set({ checkoutDetails });
            },

            async getCheckoutDetails() {
                try {
                    set({ checkoutLoading: true });
                    const checkoutResponce = await getCheckoutRest(
                        get()?.cartId
                    );
                    if (checkoutResponce?.consignments) {
                        set({ checkoutDetails: checkoutResponce });
                    } else {
                        console.error(checkoutResponce);
                    }
                } catch (error) {
                    console.error("Error:: Checkout Fetch Failed", error);
                } finally {
                    set({ checkoutLoading: false });
                }
            },

            async updateShipping(value) {
                try {
                    set({ checkoutLoading: true });
                    const { checkoutDetails, cartId } = get();
                    const checkoutResponce = await UpdateShippingMethod(
                        checkoutDetails,
                        value
                    );
                    if (checkoutResponce?.consignments) {
                        set({ checkoutDetails: checkoutResponce });
                    } else {
                        console.error(checkoutResponce);
                    }
                } catch (error) {
                    console.error("Error:: Checkout Fetch Failed", error);
                } finally {
                    set({ checkoutLoading: false });
                }
            },

            async createCheckout(cartData, formData) {
                const flag = useCountryStore?.getState()?.flag;
                try {
                    if (!cartData) {
                        console.error(Error?.CREAT_CHECKOUT_CART_DATA_MISSING);
                        return;
                    }
                    set({ checkoutLoading: true });

                    let addressInfo;
                    if (formData?.email && formData?.phone) {
                        addressInfo = formData;
                    } else {
                        addressInfo = {
                            country_code: `${flag}`,
                            shipping_method: formData?.shipping_method || null,
                        };
                    }
                    console.log("ADDRESS INFO HOOK CALL", addressInfo);
                    const checkoutResponse = await Checkout(
                        addressInfo,
                        cartData
                    );
                    if (!checkoutResponse || checkoutResponse?.error) {
                        console.error(checkoutResponse?.error);
                    } else
                        set({
                            checkoutDetails: checkoutResponse,
                            checkoutLoading: false,
                        });
                    return checkoutResponse;
                } catch (error) {
                    console.error("Checkout error:", error);
                } finally {
                    set({ checkoutLoading: false });
                }
            },

            async setCartId(cartId) {
                const {
                    clearCart,
                    createCheckout,
                    checkoutDetails,
                    cartId: storeCartId,
                } = get();
                set({ cartLoading: true });
                try {
                    const currency = useCountryStore?.getState().currency;
                    const data = await getCartRest(cartId, currency);
                    if (data?.id) {
                        if (storeCartId !== cartId && checkoutDetails)
                            await createCheckout(data);
                        setCartCookies(data.id);
                        set({ cartData: data, cartId: data.id });
                    } else clearCart();
                } catch (error) {
                    console.error("Error fetching cart:", error);
                    clearCart();
                } finally {
                    set({ cartLoading: false });
                }
            },
            setHasHydrated: (state) => {
                set({
                    hasCartHydrated: state,
                });
            },
        }),
        {
            name: "cart-store", // key for local storage
            getStorage: () => localStorage,
            partialize: (state) => ({
                cartId: state.cartId,
                cartData: state.cartData,
                checkoutDetails: state.checkoutDetails,
            }),
            onRehydrateStorage: (state) => {
                return () => state.setHasHydrated(true);
            },
        }
    )
);

export default useCartStore;
